import Modal from './Modal';

export default Modal;



// WEBPACK FOOTER //
// ./src/app/components/Modal/index.js